import { Entypo,} from '@expo/vector-icons';
import React from 'react';
import { Pressable, Text, View, Animated,  } from 'react-native';
import { ConnectionOrd } from '../~Utilities/Connection';
import { AppMain, BookItem, FontInfo, } from '../~Utilities/Constants';
import { OrdData } from '../~Utilities/Data';
import { PriceType, TransactionType } from '../~Utilities/Rq';
import Utilities from '../~Utilities/Utilities';
import OB from '../~Screens/OB';

export interface IOBOrder
{
//   manageScroll(iMsg    : number,
//                oParam? : any) : any;

  oOB       : OB;
  oBookItem : BookItem;
}

export interface IOBOrderState
{
   orders? : OBOrderProps,
   lines?  : OBOrderLines,

   // iOrders          ?: number,

   // //Buy
   // // iBuySize         ?: number,

   // iBuyLimit        ?: number,
   // iBuyLimitBr      ?: number,
   // iBuyLimitOco     ?: number,
   // iBuyLimitBrOco   ?: number,
   // iBuyLimitBrOcoU  ?: number,

   // iBuyStop         ?: number, 
   // iBuyStopBr       ?: number, 
   // iBuyStopOco      ?: number, 
   // iBuyStopBrOco    ?: number, 
   // iBuyStopBrOcoU   ?: number, 

   // //sell
   // // iSellSize        ?: number,

   // iSellLimit       ?: number, 
   // iSellLimitBr     ?: number, 
   // iSellLimitOco    ?: number, 
   // iSellLimitBrOco  ?: number, 
   // iSellLimitBrOcoU ?: number, 

   // iSellStop        ?: number, 
   // iSellStopBr      ?: number,
   // iSellStopOco     ?: number, 
   // iSellStopBrOco   ?: number, 
   // iSellStopBrOcoU  ?: number, 

   bDrag            : false,
   bCancel          : false,
   pan              : Animated.ValueXY,
   
}

/*   ---------------------------------------------------------------------   */

export class OBOrderProps
{
   iOrders          ?: number;

   iBuyLimit        ?: number;
   iBuyLimitBr      ?: number;
   iBuyLimitOco     ?: number;
   iBuyLimitBrOco   ?: number;
   iBuyLimitBrOcoU  ?: number;

   iBuyStop         ?: number; 
   iBuyStopBr       ?: number; 
   iBuyStopOco      ?: number; 
   iBuyStopBrOco    ?: number; 
   iBuyStopBrOcoU   ?: number; 

   iSellLimit       ?: number; 
   iSellLimitBr     ?: number; 
   iSellLimitOco    ?: number; 
   iSellLimitBrOco  ?: number; 
   iSellLimitBrOcoU ?: number; 

   iSellStop        ?: number; 
   iSellStopBr      ?: number;
   iSellStopOco     ?: number; 
   iSellStopBrOco   ?: number; 
   iSellStopBrOcoU  ?: number; 
}

/*   ---------------------------------------------------------------------   */

export class OBOrderLines
{
   bHzLineBr        ?: boolean;
   bHzLineOCO       ?: boolean;

   bVtUpLineBr      ?: boolean;
   bVtUpLineOCO     ?: boolean;

   bVtDnLineBr      ?: boolean;
   bVtDnLineOCO     ?: boolean;

   sBrColor         ?: string;
   sOCOColor        ?: string;
}

/*   ---------------------------------------------------------------------   */

export default class OBOrder extends React.Component<IOBOrder>
 {
   // private oPoint       = {x: 0, y: 0};
   // private panResponder : PanResponderInstance;

   private oOrd?   : OBOrderProps;
   private oLines? : OBOrderLines;

   state : IOBOrderState = {
               // iOrders    : 0,

               //Buy
               // iBuySize   : 0,

               // iBuyLimit       : 0,
               // iBuyLimitBr     : 0,
               // iBuyLimitOco    : 0,
               // iBuyLimitBrOco  : 0,

               // iBuyStop        : 0, 
               // iBuyStopBr      : 0, 
               // iBuyStopOco     : 0, 
               // iBuyStopBrOco   : 0, 
            
               //sell
               // iSellSize        : 0,

               // iSellLimit       : 0, 
               // iSellLimitBr     : 0, 
               // iSellLimitOco    : 0, 
               // iSellLimitBrOco  : 0, 
            
               // iSellStop        : 0, 
               // iSellStopBr      : 0,
               // iSellStopOco     : 0, 
               // iSellStopBrOco   : 0, 

               bDrag      : false,
               bCancel    : false,
               pan        : new Animated.ValueXY(),
               
           }
           
   /*   ------------------------------------------------------------------   */

   private oOrders : OrdData[] = new Array(0);
   private oTimer  : any;
   private bTimer  : boolean   = false;

   /*   ------------------------------------------------------------------   */

   public bIsSelected : boolean = false;

   /*   ------------------------------------------------------------------   */

   public GetOrders()
   {
   return(this.oOrders);   
   }

   /*   ------------------------------------------------------------------   */

   ClearAllOrders()
   {
   if (this.oOrders.length > 0 || this.oLines)
      {
      this.oOrders.splice(0, this.oOrders.length);

      this.oOrd        = undefined;
      this.oLines      = undefined;
      this.bIsSelected = false;

      this.setState({
                     orders : this.oOrd,
                     lines: this.oLines,

                     // iOrders          : undefined,

                     // //Buy
                     // // iBuySize         ?: number,
                  
                     // iBuyLimit        : undefined,
                     // iBuyLimitBr      : undefined,
                     // iBuyLimitOco     : undefined,
                     // iBuyLimitBrOco   : undefined,
                  
                     // iBuyStop         : undefined, 
                     // iBuyStopBr       : undefined, 
                     // iBuyStopOco      : undefined, 
                     // iBuyStopBrOco    : undefined, 
                  
                     // //sell
                     // // iSellSize        ?: number,
                  
                     // iSellLimit       : undefined, 
                     // iSellLimitBr     : undefined, 
                     // iSellLimitOco    : undefined, 
                     // iSellLimitBrOco  : undefined, 
                  
                     // iSellStop        : undefined, 
                     // iSellStopBr      : undefined,
                     // iSellStopOco     : undefined, 
                     // iSellStopBrOco   : undefined, 
      
                     // iOrders: 0, 

                     // iBuySize        : 0,

                     // iBuyLimit       : 0,
                     // iBuyLimitBr     : 0,
                     // iBuyLimitOco    : 0,
                     // iBuyLimitBrOco  : 0,

                     // iBuyStop        : 0,
                     // iBuyStopBr      : 0,
                     // iBuyStopOco     : 0,
                     // iBuyStopBrOco   : 0,

                     // iSellSize        : 0,

                     // iSellLimit       : 0,
                     // iSellLimitBr     : 0,
                     // iSellLimitOco    : 0,
                     // iSellLimitBrOco  : 0,

                     // iSellStop        : 0,
                     // iSellStopBr      : 0,
                     // iSellStopOco     : 0,
                     // iSellStopBrOco   : 0,


                     bCancel: false });
      }
   }

   /*   ------------------------------------------------------------------   */

   GetSelIds(oList : string[])
   {
   //if (this.state.bCancel)
   if (this.bIsSelected)
      {
      for (let i = 0; i < this.oOrders.length; i++)
         {
         let sSelId = this.oOrders[i].sSelId;

         if (sSelId)
            {
            oList.push(sSelId);
            }
         else
            {
            oList.push(this.oOrders[i].basket_id);
            }
         }
      }
   }

   /*   ------------------------------------------------------------------   */

   GetAValidOrder(iQty? : number)
   {
   for (let i = 0; i < this.oOrders.length; i++)
      {
      if (this.oOrders[i].linked_orders)
         continue;

      if (this.oOrders[i].oBrData)
         continue;

      if (iQty != undefined && iQty != this.oOrders[i].qty)
         continue;

      return(this.oOrders[i]);
      }
   }

   /*   ------------------------------------------------------------------   */

   UpdateOrder(oOrdData    : OrdData,
               bForce      : boolean,
               bSelected?  : boolean,
               oLineProps? : OBOrderLines)
   {
   Utilities.Sendlog("Updating order: " + oOrdData.basket_id);

   let z = Utilities.FindAny(this.oOrders, oOrdData);

   if (z == AppMain.IMAGINARY)
      {
      this.oOrders.push(oOrdData);
      }
   // else
   //    {
   //    Utilities.Sendlog("CANNOT update Order: " + oOrdData.basket_id + " price: " + oOrdData.limit_price);
   //    return;
   //    }

   // let sText = this.oOrders.length.toString();

   this.UpdateOrders(bForce, bSelected, oLineProps);
   }

   /*   ------------------------------------------------------------------   */

   UpdateLines(oLineProps : OBOrderLines,
               bSet       : boolean = true)
   {
   if (this.oLines == undefined)
      this.oLines = new OBOrderLines();

   if (oLineProps.bHzLineBr != undefined)
      this.oLines.bHzLineBr = oLineProps.bHzLineBr;

   if (oLineProps.bHzLineOCO != undefined)
      this.oLines.bHzLineOCO = oLineProps.bHzLineOCO;

   if (oLineProps.bVtDnLineBr != undefined)
      this.oLines.bVtDnLineBr = oLineProps.bVtDnLineBr;

   if (oLineProps.bVtUpLineBr != undefined)
      this.oLines.bVtUpLineBr = oLineProps.bVtUpLineBr;

   if (oLineProps.bVtDnLineOCO != undefined)
      this.oLines.bVtDnLineOCO = oLineProps.bVtDnLineOCO;

   if (oLineProps.bVtUpLineOCO != undefined)
      this.oLines.bVtUpLineOCO = oLineProps.bVtUpLineOCO;

   if (oLineProps.sBrColor != undefined)
      this.oLines.sBrColor = oLineProps.sBrColor;

   if (oLineProps.sOCOColor != undefined)
      {
      if (this.oLines.sOCOColor != 'limegreen')
         this.oLines.sOCOColor = oLineProps.sOCOColor;
      }
      
   if (bSet)
      this.setState({lines:this.oLines});

   return(this.oLines);
   }

   /*   ------------------------------------------------------------------   */

   UpdateOrders(bForce      : boolean,
                bSelected?  : boolean,
                oLineProps? : OBOrderLines)
   {
   let iBuyLimit        : number | undefined; 
   let iBuyLimitBr      : number | undefined;  
   let iBuyLimitOco     : number | undefined; 
   let iBuyLimitBrOco   : number | undefined;  
   let iBuyLimitBrOcoU  : number | undefined;  

   let iBuyStop         : number | undefined;  
   let iBuyStopBr       : number | undefined;  
   let iBuyStopOco      : number | undefined;  
   let iBuyStopBrOco    : number | undefined;  
   let iBuyStopBrOcoU   : number | undefined;  


   //sell
   let iSellLimit       : number | undefined;
   let iSellLimitBr     : number | undefined;
   let iSellLimitOco    : number | undefined;
   let iSellLimitBrOco  : number | undefined;
   let iSellLimitBrOcoU : number | undefined;

   let iSellStop        : number | undefined;  
   let iSellStopBr      : number | undefined; 
   let iSellStopOco     : number | undefined;  
   let iSellStopBrOco   : number | undefined;
   let iSellStopBrOcoU  : number | undefined;

   /*   ------------------------------------------------------------------   */

   for (let i = 0; i < this.oOrders.length; i++)
      {
      if (this.oOrders[i].txn_type_api == TransactionType.BUY)
         {
         if (this.oOrders[i].linked_orders) //oco
            {
            if (this.oOrders[i].price_type_api == PriceType.LIMIT)
               {
               if (this.oOrders[i].bracket_type && !this.oOrders[i].org_basket_id)
                  iBuyLimitBrOco = (iBuyLimitBrOco? iBuyLimitBrOco : 0) + this.oOrders[i].qty;
               else
                  iBuyLimitOco = (iBuyLimitOco? iBuyLimitOco : 0) + this.oOrders[i].qty;
               }
            else //stop
               {
               if (this.oOrders[i].bracket_type && !this.oOrders[i].org_basket_id)
                  iBuyStopBrOco = (iBuyStopBrOco? iBuyStopBrOco : 0) + this.oOrders[i].qty;
               else
                  iBuyStopOco = (iBuyStopOco? iBuyStopOco : 0) + this.oOrders[i].qty;
               }
            }
         else
            {
            if (this.oOrders[i].price_type_api == PriceType.LIMIT)
               {
               if (this.oOrders[i].bracket_type)
                  {
                  iBuyLimitBr = (iBuyLimitBr? iBuyLimitBr : 0) + this.oOrders[i].qty;
                  }
               else if (this.oOrders[i].oBrData)
                  {
                  iBuyLimitBrOcoU = (iBuyLimitBrOcoU? iBuyLimitBrOcoU : 0) + this.oOrders[i].qty;   
                  }
               else
                  {
                  iBuyLimit = (iBuyLimit? iBuyLimit : 0) + this.oOrders[i].qty;
                  }
               }
            else //stop
               {
               if (this.oOrders[i].bracket_type)
                  {
                  iBuyStopBr = (iBuyStopBr? iBuyStopBr : 0) + this.oOrders[i].qty;
                  }
               else if (this.oOrders[i].oBrData)
                  {
                  iBuyStopBrOcoU = (iBuyStopBrOcoU? iBuyStopBrOcoU : 0) + this.oOrders[i].qty;   
                  }
               else
                  iBuyStop = (iBuyStop? iBuyStop : 0) + this.oOrders[i].qty;
               }
            }
         }


      else //Sell
         {

         if (this.oOrders[i].linked_orders) //oco
            {
            if (this.oOrders[i].price_type_api == PriceType.LIMIT)
               {
               if (this.oOrders[i].bracket_type && !this.oOrders[i].org_basket_id)
                  iSellLimitBrOco = (iSellLimitBrOco? iSellLimitBrOco : 0) + this.oOrders[i].qty;
               else
                  iSellLimitOco = (iSellLimitOco? iSellLimitOco : 0) + this.oOrders[i].qty;
               }
            else //stop
               {
               if (this.oOrders[i].bracket_type && !this.oOrders[i].org_basket_id)
                  iSellStopBrOco = (iSellStopBrOco? iSellStopBrOco : 0) + this.oOrders[i].qty;
               else
                  iSellStopOco = (iSellStopOco? iSellStopOco : 0) + this.oOrders[i].qty;
               }
            }
         else
            {
            if (this.oOrders[i].price_type_api == PriceType.LIMIT)
               {
               if (this.oOrders[i].bracket_type)
                  {
                  iSellLimitBr = (iSellLimitBr? iSellLimitBr : 0) + this.oOrders[i].qty;
                  }
               else if (this.oOrders[i].oBrData)
                  {
                  iSellLimitBrOcoU = (iSellLimitBrOcoU? iSellLimitBrOcoU : 0) + this.oOrders[i].qty;   
                  }                  
               else
                  {
                  iSellLimit = (iSellLimit? iSellLimit : 0) + this.oOrders[i].qty;
                  }
               }
            else //stop
               {
               if (this.oOrders[i].bracket_type)
                  iSellStopBr = (iSellStopBr? iSellStopBr : 0) + this.oOrders[i].qty;
               else if (this.oOrders[i].oBrData)
                  iSellStopBrOcoU = (iSellStopBrOcoU? iSellStopBrOcoU : 0) + this.oOrders[i].qty;   
               else
                  iSellStop = (iSellStop? iSellStop : 0) + this.oOrders[i].qty;
               }
            }
         }
      }

   /*   ------------------------------------------------------------------   */

   // if (this.oOrders.length == 0)
   //    {
   //    this.oOrd = undefined;
   //    this.setState({orders:this.oOrd, 
   //                   bCancel: bSelected? bSelected : bForce? false : this.state.bCancel
   //                  });
   //    return;
   //    }

   // if (this.oOrd == undefined)
   //    this.oOrd = new OBOrderProps();


   // if (bForce              == false && 
   //     this.oOrders.length == 0 && 
   //     this.oOrd           == undefined)
   //    return;

   if (bForce                              == true                   ||
       //this.state.orders                   != this.oOrd              ||
       this.state.orders?.iOrders          != (this.oOrders.length? this.oOrders.length : undefined) ||

       this.state.orders?.iBuyLimit        != iBuyLimit        ||
       this.state.orders?.iSellLimit       != iSellLimit       ||

       this.state.orders?.iBuyStop         != iBuyStop         ||
       this.state.orders?.iSellStop        != iSellStop        ||

       this.state.orders?.iBuyLimitBr      != iBuyLimitBr      ||
       this.state.orders?.iBuyLimitOco     != iBuyLimitOco     ||
       this.state.orders?.iBuyLimitBrOco   != iBuyLimitBrOco   ||
       this.state.orders?.iBuyLimitBrOcoU  != iBuyLimitBrOcoU  ||

       this.state.orders?.iBuyStopBr       != iBuyStopBr       ||
       this.state.orders?.iBuyStopOco      != iBuyStopOco      ||
       this.state.orders?.iBuyStopBrOco    != iBuyStopBrOco    ||
       this.state.orders?.iBuyStopBrOcoU   != iBuyStopBrOcoU   ||


       this.state.orders?.iSellLimitBr     != iSellLimitBr     ||
       this.state.orders?.iSellLimitOco    != iSellLimitOco    ||
       this.state.orders?.iSellLimitBrOco  != iSellLimitBrOco  ||
       this.state.orders?.iSellLimitBrOcoU != iSellLimitBrOcoU ||


       this.state.orders?.iSellStopBr      != iSellStopBr      ||
       this.state.orders?.iSellStopOco     != iSellStopOco     ||
       this.state.orders?.iSellStopBrOco   != iSellStopBrOco   ||
       this.state.orders?.iSellStopBrOcoU  != iSellStopBrOcoU
       )
       {
      //Utilities.Sendlog("**OB Orders : " + this.oOrders.length + " Buy: " + iBuyLimit + " Sell: " + iSellLimit);

      if (this.oOrders.length == 0)
         this.oOrd = undefined;
      else
         {
         if (this.oOrd == undefined)
            this.oOrd = new OBOrderProps();

         this.oOrd.iOrders          = this.oOrders.length;
         
         this.oOrd.iBuyLimit        = iBuyLimit       ;
         this.oOrd.iBuyLimitBr      = iBuyLimitBr     ;
         this.oOrd.iBuyLimitOco     = iBuyLimitOco    ;
         this.oOrd.iBuyLimitBrOco   = iBuyLimitBrOco  ;
         this.oOrd.iBuyLimitBrOcoU  = iBuyLimitBrOcoU ;

         this.oOrd.iBuyStop         = iBuyStop        ;
         this.oOrd.iBuyStopBr       = iBuyStopBr      ;
         this.oOrd.iBuyStopOco      = iBuyStopOco     ;
         this.oOrd.iBuyStopBrOco    = iBuyStopBrOco   ;
         this.oOrd.iBuyStopBrOcoU   = iBuyStopBrOcoU  ;

         this.oOrd.iSellLimit       = iSellLimit      ;
         this.oOrd.iSellLimitBr     = iSellLimitBr    ;
         this.oOrd.iSellLimitOco    = iSellLimitOco   ;
         this.oOrd.iSellLimitBrOco  = iSellLimitBrOco ;
         this.oOrd.iSellLimitBrOcoU = iSellLimitBrOcoU;

         this.oOrd.iSellStop        = iSellStop       ;
         this.oOrd.iSellStopBr      = iSellStopBr     ;
         this.oOrd.iSellStopOco     = iSellStopOco    ;
         this.oOrd.iSellStopBrOco   = iSellStopBrOco  ;
         this.oOrd.iSellStopBrOcoU  = iSellStopBrOcoU ;


         // this.oOrd.bVtUpLineBr    = true;
         // this.oOrd.bVtDnLineBr    = true;

         // this.oOrd.bVtUpLineOCO  = true;
         // this.oOrd.bHzLineOCO    = true;

         // this.oOrd.bVtDnLineBr  = true;
         // this.oOrd.bHzLineBr    = true;
         }

      if (oLineProps)
         this.setState({orders: this.oOrd,
                        lines: this.UpdateLines(oLineProps, false),
                        bCancel: bSelected? bSelected : bForce? false : this.state.bCancel});
      else
         this.setState({orders: this.oOrd,
                        bCancel: bSelected? bSelected : bForce? false : this.state.bCancel});


      this.bIsSelected = bSelected? bSelected : bForce? false : this.bIsSelected;

      //  this.setState({iOrders: this.oOrders.length, 
         
      //                 iBuyLimit        : iBuyLimit       ,
      //                 iBuyLimitBr      : iBuyLimitBr     ,
      //                 iBuyLimitOco     : iBuyLimitOco    ,
      //                 iBuyLimitBrOco   : iBuyLimitBrOco  ,
      //                 iBuyLimitBrOcoU  : iBuyLimitBrOcoU ,

      //                 iBuyStop         : iBuyStop        ,
      //                 iBuyStopBr       : iBuyStopBr      ,
      //                 iBuyStopOco      : iBuyStopOco     ,
      //                 iBuyStopBrOco    : iBuyStopBrOco   ,
      //                 iBuyStopBrOcoU   : iBuyStopBrOcoU  ,

      //                 iSellLimit       : iSellLimit      ,
      //                 iSellLimitBr     : iSellLimitBr    ,
      //                 iSellLimitOco    : iSellLimitOco   ,
      //                 iSellLimitBrOco  : iSellLimitBrOco ,
      //                 iSellLimitBrOcoU : iSellLimitBrOcoU,

      //                 iSellStop        : iSellStop       ,
      //                 iSellStopBr      : iSellStopBr     ,
      //                 iSellStopOco     : iSellStopOco    ,
      //                 iSellStopBrOco   : iSellStopBrOco  ,
      //                 iSellStopBrOcoU  : iSellStopBrOcoU ,
         
      //                 bCancel: bSelected? bSelected : bForce? false : this.state.bCancel});
       }
   }

   /*   ------------------------------------------------------------------   */

   RemoveOrder(oOrdData : OrdData)
   {
   Utilities.Sendlog("Removing order: " + oOrdData.basket_id);

   if (Utilities.FindAndDeleteAny(this.oOrders, oOrdData) == false)
      return;

   if (this.oOrders.length == 0)
      {
      this.oOrd        = undefined;
      this.bIsSelected = false;

      this.setState({orders: this.oOrd,
                     bCancel:false});

      // this.setState({iOrders: 0,
      //                iBuyLimit:0, iSellLimit:0,
      //                iBuyStop:0, iSellStop:0, bCancel:false});
      }
   else
      this.UpdateOrders(false);
   }

   /*   ------------------------------------------------------------------   */

   constructor(props)
   {
   super(props);

   this.UpdateOrder    = this.UpdateOrder.bind(this);
   this.RemoveOrder    = this.RemoveOrder.bind(this);
   this.CancelOrders   = this.CancelOrders.bind(this);
   this.ModifyOrders   = this.ModifyOrders.bind(this);
   this.ClearAllOrders = this.ClearAllOrders.bind(this);
   this.GetOrders      = this.GetOrders.bind(this);
   
   this.UpdateOrders   = this.UpdateOrders.bind(this);
   this.UpdateLines    = this.UpdateLines.bind(this);

   this.GetAValidOrder = this.GetAValidOrder.bind(this);
   //this.UpdateOrders   = this.UpdateOrders.bind(this);
   this.EnableCancel   = this.EnableCancel.bind(this);
   this.DisableCancel  = this.DisableCancel.bind(this);
   this.StopTimer      = this.StopTimer.bind(this);
   this.OnTime         = this.OnTime.bind(this);
   this.GetSelIds      = this.GetSelIds.bind(this);

   this.renderLines    = this.renderLines.bind(this);
   this.renderOrders   = this.renderOrders.bind(this);

   // this.state.pan.addListener((value) => 
   // {
   // this.oPoint = value
   // console.log(this.oPoint);
   // });

   // this.panResponder = PanResponder.create({
   //    // onStartShouldSetPanResponder: (e, gesture) => true,
   //    // onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
   //     onMoveShouldSetPanResponder: (e, gesture) => true,
   //     onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
   //     onPanResponderTerminationRequest: (e, gesture) => false,

   //    onPanResponderGrant: (e, gesture) => {
   //       //this.props.manageScroll(Draggable.SCROLL_DISABLE);

   //       console.log("grant: " + this.oPoint.y);

   //       this.state.pan.setOffset({
   //                                  x: this.oPoint.x,
   //                                  y: this.oPoint.y
   //                                  });
   //       this.state.pan.setValue({ x:0, y:0});

   //       this.setState({bDrag: true});
   //     },

   //    onPanResponderMove: (e, gesture) => {
   //       this.state.pan.setValue({
   //          x: gesture.dx,
   //          y: gesture.dy
   //       });
   //    },

   //    onPanResponderTerminate: (e, gesture) => {
   //       //this.props.manageScroll(Draggable.SCROLL_ENABLE);
   //       this.setState({bDrag: false})
   //    },

   //    onPanResponderReject: (e, gesture) => {alert("reject")},

   //    onPanResponderRelease: (e, gesture) => {
   //       //this.props.manageScroll(Draggable.SCROLL_ENABLE);

   //       let toval = Math.round(this.oPoint.y/70) * 70;
   //       console.log("y=" + this.oPoint.y + " rounded: " + toval);

   //       // if (this.oPoint.y < 3)
   //       //    {
   //       //    this.state.bCancel? this.CancelOrders() : this.EnableCancel()
   //       //    return;
   //       //    }

   //       this.state.pan.flattenOffset();
   //       this.oPoint.y = 0;
   //       this.oPoint.x = 0;
         
   //       this.state.pan.setValue({x:0, y:toval});

   //       this.setState({bDrag: false})
   //    }
   // });

   }

   /*   ------------------------------------------------------------------   */

   StopTimer()
   {
   if (this.bTimer == true)
      {
      clearInterval(this.oTimer);
      this.bTimer = false;
      }
   }

   /*   ------------------------------------------------------------------   */

   EnableCancel(bLong : boolean)
   {
   this.bIsSelected = true;
   this.setState({bCancel:true});

   //console.log("modify: " + this.props.oOB)
   if (bLong == false)
      this.props.oOB?.oOBModify?.Show(this, this.props.oOB.obOrderRef);
   else
      this.props.oOB?.oOBModify?.ShowAdd(this);
   //this.oTimer = setInterval(this.OnTime, 2000);
   //this.bTimer = true;
   }

   /*   ------------------------------------------------------------------   */

   DisableCancel(bStateOnly : boolean = false)
   {
   this.bIsSelected = false;
   this.setState({bCancel:false});

   if (bStateOnly == true)
      return;
      
   this.props.oOB?.oOBModify?.Hide(this);
   //this.oTimer = setInterval(this.OnTime, 2000);
   //this.bTimer = true;
   }

   /*   ------------------------------------------------------------------   */

   OnTime()
   {
   this.bIsSelected = false;
   this.setState({bCancel:false});
   this.StopTimer();
   }

   /*   ------------------------------------------------------------------   */

    componentDidMount() 
    {
    }

    /*   ------------------------------------------------------------------   */

    componentWillUnmount() 
    {
    }

   /*   ------------------------------------------------------------------   */    

   CancelOrders()
   {
   this.StopTimer();

   for (let i = 0; i < this.oOrders.length; i++)
      ConnectionOrd.oConn?.Rq_CancelOrder(this.oOrders[i].acc_key, 
                                          this.oOrders[i].basket_id,
                                          "Order Book, Cancel All Button",);
   }

   /*   ------------------------------------------------------------------   */

   ModifyOrders(iLevel : number)
   {
   this.StopTimer();

   Utilities.Sendlog("Modifying at level: " + this.props.oBookItem.PriceKey);
   
   let dNewPrice = this.props.oBookItem.Price +
                     (iLevel * this.props.oOB.props.oData.qpc);

   for (let i = 0; i < this.oOrders.length; i++)
      {
      if (this.oOrders[i].oBrData)
         {
         let dPrice = this.oOrders[i].limit_price;

         if (dPrice != undefined)
            {
            let iLevel =  Math.trunc(Math.abs(dPrice - dNewPrice)/
                                       this.props.oOB.props.oData.qpc);

            ConnectionOrd.oConn?.Rq_ModifyBkt(this.oOrders[i].acc_key, 
                                              this.oOrders[i].basket_id,
                                              iLevel,
                                              this.oOrders[i],
                                              "Order Book, Modify Button");
            }
         }
      else
         {
         ConnectionOrd.oConn?.Rq_ModifyOrder(this.oOrders[i].acc_key, 
                                             this.oOrders[i].basket_id,
                                             Utilities.round(dNewPrice,
                                             this.props.oOB.props.oData.f2qp),
                                             "Order Book, Modify Button");
         }                                    
      }
   }

   /*   ------------------------------------------------------------------   */

   renderLines()
   {
   if (!this.state.lines)
      return(null);

   return(
      <View style={{flexDirection:'column', height:'100%', marginLeft:4, width:6}}>

      <View style={{backgroundColor:'transparent', flex:1,
                  borderLeftWidth:this.state.lines?.bVtUpLineOCO? 1 : 0, borderLeftColor:this.state.lines?.sOCOColor, 
                  borderRightWidth:this.state.lines?.bVtUpLineBr? 1 : 0, borderRightColor:this.state.lines?.sBrColor,}}>
      </View>


      <View style={{display:this.state.lines?.bHzLineOCO? 'flex' : 'none', height:this.state.lines?.bHzLineOCO? 2 : 0, backgroundColor:this.state.lines?.sOCOColor}}></View>
      

      <View style={{backgroundColor:'transparent', flex:1,
                    borderLeftWidth:this.state.lines?.bVtDnLineOCO? 1 : 0, borderLeftColor:this.state.lines?.sOCOColor, 
                    borderRightWidth:this.state.lines?.bVtDnLineBr? 1 : 0, borderRightColor:this.state.lines?.sBrColor,}}>
      </View>

   </View>

   );
   }

   /*   ------------------------------------------------------------------   */

   renderOrders()
   {
   if (!this.state.orders)
      return(null);

   return(
      <Pressable 
      //pressRetentionOffset={20}
      style={{marginLeft:!this.state.lines? 9 : 0, justifyContent:'center', flexDirection:'row', minWidth:50, overflow:'hidden', backgroundColor: this.state.bCancel? '#ea3c53' : 'transparent', borderRadius:5, paddingRight:4}}
      onPress={()=>{ this.state.bCancel? this.DisableCancel() : this.EnableCancel(false) }}
      onLongPress={()=>{this.state.bCancel? this.DisableCancel() : this.EnableCancel(true)}}
      >
      


      {/* <FontAwesome style={{marginTop:-1, marginLeft:2}} name="close" size={14} color="#ff355e" /> */}

      {/* <Text style={{fontVariant: ['tabular-nums'], marginTop:0, fontSize:12, fontWeight:'bold', }}>
         {this.state.iBuyLimit? "b" + this.state.iBuyLimit : "" + this.state.iSellLimit? "s" + this.state.iSellLimit : ""} 
      </Text> */}
   <View style={{flex:1, height:2, alignSelf:'center', backgroundColor: this.state.lines?.bHzLineBr? this.state.lines?.sBrColor : this.state.lines?.bHzLineOCO? this.state.lines?.sOCOColor : 'transparent'}}></View>

   {/* <View style={{alignContent:'center', alignItems:'center'}}> */}
   <View style={{flexDirection:'row', backgroundColor:'transparent',  }}>

   {/* Buy Limit */}
   <Text style={this.state.orders.iBuyLimit || this.state.orders.iBuyLimitOco || this.state.orders.iBuyLimitBr || this.state.orders.iBuyLimitBrOco || this.state.orders.iBuyLimitBrOcoU? 
                [FontInfo.appStyles.txt_bold, {color:this.state.bCancel?'white' : FontInfo.sBuyText}] : {display:'none'}}>
      {
       (this.state.orders.iBuyLimitBrOcoU? "(b" + this.state.orders.iBuyLimitBrOcoU  + ")" : "") +
       (this.state.orders.iBuyLimitOco? "ob" + this.state.orders.iBuyLimitOco : "") +
       (this.state.orders.iBuyLimitBrOco? "ob[" + this.state.orders.iBuyLimitBrOco + "]" : "") +
       (this.state.orders.iBuyLimitBr? "b[" + this.state.orders.iBuyLimitBr + "]" : "") +
       (this.state.orders.iBuyLimit? "b" + this.state.orders.iBuyLimit : "")
       } 
   </Text>

   {/* Sell Limit */}
   <Text style={this.state.orders.iSellLimit || this.state.orders.iSellLimitOco || this.state.orders.iSellLimitBr || this.state.orders.iSellLimitBrOco || this.state.orders.iSellLimitBrOcoU?
                [FontInfo.appStyles.txt_bold, {color:this.state.bCancel?'white' : 'hotpink'}] : {display:'none'}}>
      {
       (this.state.orders.iSellLimitBrOcoU? "(s" + this.state.orders.iSellLimitBrOcoU + ")" : "") +
       (this.state.orders.iSellLimitOco? "os" + this.state.orders.iSellLimitOco : "") +
       (this.state.orders.iSellLimitBrOco? "os[" + this.state.orders.iSellLimitBrOco + "]" : "") +
       (this.state.orders.iSellLimitBr? "s[" + this.state.orders.iSellLimitBr + "]" : "") +
       (this.state.orders.iSellLimit? "s" + this.state.orders.iSellLimit : "")
      }
   </Text>


   {/* Buy Stop */}
   <View style={this.state.orders.iBuyStop || this.state.orders.iBuyStopOco || this.state.orders.iBuyStopBr || this.state.orders.iBuyStopBrOco || this.state.orders.iBuyStopBrOcoU? 
                {flexDirection:'row', justifyContent:'center', alignItems:'center'} : {display:'none'}}>
   {/* <MaterialCommunityIcons style={{marginTop:3}} name="stop" size={12} color="dodgerblue" /> #cd5c5c */}
   <Entypo name="circle-with-minus" size={12} color={this.state.bCancel?'white' : "red"} />
   <Text style={[FontInfo.appStyles.txt_bold, {marginLeft:0, color:this.state.bCancel?'white' : FontInfo.sBuyText}]}>
      {
       (this.state.orders.iBuyStopBrOcoU? "(b" + this.state.orders.iBuyStopBrOcoU + ")" : "") +
       (this.state.orders.iBuyStopOco? "ob" + this.state.orders.iBuyStopOco : "") +
       (this.state.orders.iBuyStopBrOco? "ob[" + this.state.orders.iBuyStopBrOco + "]" : "") +
       (this.state.orders.iBuyStopBr? "b[" + this.state.orders.iBuyStopBr + "]" : "") +
       (this.state.orders.iBuyStop? "b" + this.state.orders.iBuyStop : "")
      }
   </Text>
   </View>


   {/* Sell Stop */}
   <View style={this.state.orders.iSellStop || this.state.orders.iSellStopOco || this.state.orders.iSellStopBr || this.state.orders.iSellStopBrOco || this.state.orders.iSellStopBrOcoU? 
                {flexDirection:'row', justifyContent:'center', alignItems:'center'}:{display:'none'}}>
   {/* <MaterialCommunityIcons style={{marginTop:3}} name="stop" size={12} color="hotpink" /> */}
   <Entypo name="circle-with-minus" size={12} color={this.state.bCancel?'white' : "red"} />
   {/* <AntDesign name="minuscircle" size={12} color={this.state.bCancel?'white' : "red"} /> */}
   <Text style={[FontInfo.appStyles.txt_bold, {marginLeft:0, color:this.state.bCancel?'white' : 'hotpink'}]}>
      {
       (this.state.orders.iSellStopBrOcoU? "(s" + this.state.orders.iSellStopBrOcoU + ")" : "") +
       (this.state.orders.iSellStopOco? "os" + this.state.orders.iSellStopOco : "") +
       (this.state.orders.iSellStopBrOco? "os[" + this.state.orders.iSellStopBrOco + "]" : "") +
       (this.state.orders.iSellStopBr? "s[" + this.state.orders.iSellStopBr + "]" : "") +
       (this.state.orders.iSellStop? "s" + this.state.orders.iSellStop : "")
      }
   </Text>
   </View>


   </View>
   {/* </View> */}


   <View style={{flex:1, backgroundColor:'transparent'}}></View>

   </Pressable>

   );
   }

   /*   ------------------------------------------------------------------   */

   render() 
     {
      if (!this.state.orders && !this.state.lines)
      return (
               <View style={{minWidth:75, backgroundColor:'transparent'}}>
               {/* <View style={{marginLeft:3, alignSelf:'flex-start', backgroundColor:'transparent', width:6, height: '100%', 
               borderLeftWidth:1, borderLeftColor:'hotpink', borderRightWidth:1, borderRightColor:'dodgerblue',}}>
               </View> */}
               </View>
             );
      else
      return (
            <View style={{minWidth:75, maxWidth:75, alignContent:'center', alignItems:'center', flexDirection:'row' }}>

            <this.renderLines/>
            <this.renderOrders/>

            {/* <View style={{borderRadius:5, backgroundColor:'#EEEEEE', minWidth:20, alignContent:'center', alignItems:'center', }}> */}
            {/* <Text style={{fontVariant: ['tabular-nums'], marginTop:0, fontSize:12, fontWeight:'bold', }}> {this.oOrders.length.toString()} </Text> */}
            {/* </View>  */}

            {/* </View> */}

            </View>
      );
   }
}